import React, { useEffect, useState, useRef } from "react";
import { Card } from "react-bootstrap";
import Chart from "react-google-charts";
import { usePDF } from "react-to-pdf";
import * as XLSX from "xlsx";

function CustomReportPage() {
  const containerRef = useRef<HTMLDivElement>(null);

  const [bookingTotal, setBookingTotal] = useState(0);
  const [billingTotal, setBillingTotal] = useState("");
  const [cancellationTotal, setCancellationTotal] = useState(0);
  // Mantengo la estructura con cabecera para Chart
  const [historicalBooking, setHistoricalBooking] = useState<any[][]>([
    ["Día", "Reservas"],
  ]);
  const [historicalBilling, setHistoricalBilling] = useState<any[][]>([
    ["Día", "Facturación"],
  ]);

  useEffect(() => {
    const startDate = new Date("2025-04-01");
    const endDate = new Date("2025-04-30");
    const bookings: any[][] = [["Día", "Reservas"]];
    const billings: any[][] = [["Día", "Facturación"]];
    let totalB = 0;
    let totalF = 0;
    const curr = new Date(startDate);

    while (curr <= endDate) {
      const rndBooking = Math.floor(Math.random() * 10);
      const rndBilling =
        rndBooking *
        (Math.floor(Math.random() * 10) + 15) *
        (Math.floor(Math.random() * 7) + 1);

      const dayStr = curr.toLocaleDateString("es-ES");
      bookings.push([dayStr, rndBooking]);
      billings.push([dayStr, rndBilling]);

      totalB += rndBooking;
      totalF += rndBilling;
      curr.setDate(curr.getDate() + 1);
    }

    setBookingTotal(totalB);
    setBillingTotal(
      new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(
        totalF
      )
    );
    setCancellationTotal(Math.ceil(totalB * 0.01));
    setHistoricalBooking(bookings);
    setHistoricalBilling(billings);
  }, []);

  // Hook para exportar a PDF
  const { toPDF, targetRef } = usePDF({ filename: "report.pdf" });

  // Función para exportar a Excel (.xlsx) solo con columnas de datos
  const exportToCSV = () => {
    let csvContent = "";
  
    // -------- Sección Resumen --------
    csvContent += "Resumen\n";
    csvContent += "Métrica,Valor\n";
    csvContent += `Total Reservas,${bookingTotal}\n`;
    csvContent += `Total Facturación,${billingTotal}\n`;
    csvContent += `Total Cancelaciones,${cancellationTotal}\n\n`;
  
    // -------- Sección Histórico Reservas --------
    csvContent += "Histórico Reservas\n";
    csvContent += "Día,Reservas\n";
    historicalBooking.slice(1).forEach(([día, res]) => {
      csvContent += `${día},${res}\n`;
    });
  
    csvContent += "\n";
  
    // -------- Sección Histórico Facturación --------
    csvContent += "Histórico Facturación\n";
    csvContent += "Día,Facturación\n";
    historicalBilling.slice(1).forEach(([día, fac]) => {
      csvContent += `${día},${fac}\n`;
    });
  
    // -------- Descargar como archivo .csv --------
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
  
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "reporte-abril.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  

  return (
    <div className="container" ref={targetRef}>
      <div className="d-flex justify-content-end mb-3">
        <button className="btn btn-success" onClick={exportToCSV}>
          Exportar CSV
        </button>
        <button className="btn btn-primary ms-2" onClick={() => toPDF()}>
          Exportar PDF
        </button>
      </div>

      {/* Vista original con Gráficas */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Mes abril</h3> 2025-04-01 - 2025-04-30
      </div>
      <div className="row">
        <div className="col-3">
          <Card>
            <Card.Header>Total de Reservas</Card.Header>
            <Card.Body>
              <div className="report">{bookingTotal}</div>
            </Card.Body>
          </Card>
        </div>
        <div className="col-6">
          <Card>
            <Card.Header>Total de Facturación</Card.Header>
            <Card.Body>
              <div className="report">{billingTotal}</div>
            </Card.Body>
          </Card>
        </div>
        <div className="col-3">
          <Card>
            <Card.Header>Total de Cancelaciones</Card.Header>
            <Card.Body>
              <div className="report">{cancellationTotal}</div>
            </Card.Body>
          </Card>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-12">
          <Card>
            <Card.Header>Histórico de reservas</Card.Header>
            <Card.Body>
              <Chart
                chartType="Bar"
                data={historicalBooking}
                width="100%"
                height="400px"
                legendToggle
              />
            </Card.Body>
          </Card>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-12">
          <Card>
            <Card.Header>Histórico de facturación</Card.Header>
            <Card.Body>
              <Chart
                chartType="Bar"
                data={historicalBilling}
                width="100%"
                height="400px"
                legendToggle
              />
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default CustomReportPage;
